import Edit from '../../../base/forms/user/Edit';

const edit: Edit = {
  header: 'Benutzer bearbeiten',
  submit: 'Bearbeiten'
};

export default edit;
